import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';

class LuSubscriptionPlanFeatureSubscriptionPlanAppResource extends AppResource {

  /**
   * @returns {string}
   */
  appResourceType() {
    return 'lu-subscription-plan-feature-subscription-plan';
  }

  /**
   * @returns {string}
   */
  appResourceApiPrefix() {
    return 'lus/subscriptions/plans/features/subscriptions/plans';
  }

  /**
   * @returns {*[]}
   */
  hidden() {
    return super.hidden().concat([
    ]);
  }

  /**
   * @returns {*[]}
   */
  fillable() {
    return [
      'lookupSubscriptionPlanFeatureUuid',
      'subscriptionPlanUuid',
      'display',
      'highlight',
      'highlightOrder',
      'label',
    ];
  }

  /**
   * @returns {*[]}
   */
  relationMap() {
    return [
    ];
  }

  /**
   * @returns {*[]}
   */
  relationForeignKeys() {
    return [
    ];
  }

  /**
   * @returns {*}
   */
  validationRules() {
    return {
      lookupSubscriptionPlanFeatureUuid: {
        type: 'string',
        presence: true,
      },
      subscriptionPlanUuid: {
        type: 'string',
        presence: true,
      },
      display: {
        type: 'boolean',
      },
      highlight: {
        type: 'boolean',
      },
      highlightOrder: {
        type: 'integer',
      },
      label: {
        type: 'string',
      },
    };
  }
}

export default LuSubscriptionPlanFeatureSubscriptionPlanAppResource;
